import React from 'react';
import PropTypes from 'prop-types';

import { PERIOD_LABEL, GRADE_LABEL } from '../../constants/enrollment';
import { localizeDate } from '../../common/localization';
import { useAppContext } from '../../common/contexts/AppContext';

const WindowData = ({ gradeLevel }) => {
    const { bmWindow } = useAppContext();
    return (
        <>
            <div className='dashboard-enrollment'>
                {gradeLevel && <div className='dashboard-grade'>{GRADE_LABEL[gradeLevel]}</div>}
                <div className='dashboard-period'>{bmWindow && PERIOD_LABEL[bmWindow.period]}</div>
            </div>

            <div className='dashboard-window-dates'>
                {bmWindow &&
                    `${localizeDate(bmWindow.startDate)} - ${localizeDate(bmWindow.endDate)}`}
            </div>
        </>
    );
};

WindowData.propTypes = {
    gradeLevel: PropTypes.string,
};

WindowData.defaultProps = {
    gradeLevel: '',
};

export default WindowData;
